// 操作日志
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">操作日志</span>
                    </div>
                    <div class="search-content mar_b" style="margin-top:-15px;margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <!--<el-form-item prop="order_type" label="操作类型：" label-width="90px">
                                <el-select v-model="query.order_type" placeholder="请选择">
                                    <el-option label="全部订单" value="0"></el-option>
                                    <el-option label="待取货" selected value="1"></el-option>
                                    <el-option label="已取货" value="2"></el-option>
                                    <el-option label="订单完成" value="3"></el-option>
                                    <el-option label="无效订单" value="4"></el-option>
                                    <el-option label="已退货" value="5"></el-option>
                                    <el-option label="未结清" value="6"></el-option>
                                    <el-option label="已结清" value="7"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="picino" label="批次号：" label-width="90px">
                                <el-input v-model="query.picino" placeholder="请输入"></el-input>
                            </el-form-item>-->
                            <el-form-item prop="op_action" label="动作：" label-width="90px">
                                <el-input v-model="query.op_action" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="userid" label="操作人：" label-width="90px">
                                <el-input v-model="query.userid" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="op_time" label="日期：" label-width="90px">
                                <el-date-picker v-model="query.op_time" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right;margin-right:100px;">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item><br>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-table :data="systemLogList" border height="550" ref="refTable"
                        :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                            <el-table-column type="selection" align="center" width="40"></el-table-column>
                            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
                            <el-table-column align="center" width="150" prop="opModule" label="类别" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="150" prop="opAction" label="动作" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="200" prop="userId" label="会员" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="220" prop="opContent" label="详情"></el-table-column>
                            <el-table-column align="center" width="100" prop="op_num" label="数量" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="200" prop="userId" label="操作人" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="210" prop="opTime" label="数据日期" :formatter="formatterDate" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </div>
                    <!--分页-->
                    <div class="block tar mar_t">
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[20, 50, 100, 200]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    export default {
        data() {
            return {
                isAble: true,
                isq: '',
                inv_status: '',
                dateList: {},
                addDataForm: [],
                addDataForm3: [],
                dataOnLineListSelections: [],
                certnoList: [],
                systemLogList:[],
                certnoStr: '',
                aimDiffBasicList: [{'project':'周报',
                    'ruleItemData':[{'project':'123'}]},
                    {'project':'周报','ruleItemData':[{'project':'123'}]}
                ],
                // 查询
                query: {
                    clzt: '',
                    khmc: '',
                    data_dt: [],
                    order_date: [],
                    ct2: '',
                    order_type:'',
                    danhao: '',
                    huiyuan: ''
                },
                expands: [],
                queryDate: '',
                // queryDate: this.getNowTime(),
                date_dt_str: '',
                // 列表
                dateList: [],
                dayList: [],
                // 分页
                pager: {
                    page: 1,
                    rows: 50,
                    total: 0
                },
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                console.log(rows)
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                console.log(page)
                this.pager.page = page;
                this.selectList();
            },
            // 导出全部数据
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['姓名', '年龄']
                    const filterVal = ['project', 'start_date']
                    const list = this.aimDiffBasicList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '货品数据信息')
                })
            },
            // 加载操作日志列表
            selectList() {
                let _this = this;
                util.publicget('/diamond/querySystemLogListPageModel', {
                    // picino: _this.query.picino,
                    equalsUserId: _this.query.userid,
                    equalsOpAction: _this.query.op_action,
                    greaterEqualsOpTime: _this.query.op_time == null ? "" : _this.query.op_time[0],
                    lessEqualsOpTime: _this.query.op_time == null ? "" : _this.query.op_time[1],
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.systemLogList = res.obj;
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.opTime), 'yyyy-MM-dd hh:mm:ss');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            }
        },
        mounted() {
            this.selectList();
            //this.selectAimDiffList();
        }
    };
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/diamond/diamondLogList.vue